<template>
  <v-layout justify-center align-center fill-height>
    <v-flex xs6 sm5 md4 lg3>

      <v-form v-model="valid" @submit.prevent="login" ref="form" >
        <v-card >
          <v-card-title class="headline">
            <h3>{{$t('app_name')}}</h3>
          </v-card-title>

          <v-card-text>
            <v-text-field
              :label= "$t('acc_username_hint')" 
              name="login"
              type="text"
              v-model="username"
              :rules="usernameRules"
            ></v-text-field>

            <v-text-field
              name="password" 
              :label="$t('acc_pass_hint')" 
              v-model="password" 
              :type="showPassword ? 'text' : 'password'"
              :append-icon="showPassword ? 'visibility_off' : 'visibility'"
              @click:append="showPassword = !showPassword"
              :rules="passwordRules"
            ></v-text-field>

             <v-text-field v-if="!loginState"
              name="password" 
              :label="$t('acc_pass_hint')" 
              v-model="confirmPassword" 
              :type="showPassword ? 'text' : 'password'"
              :append-icon="showPassword ? 'visibility_off' : 'visibility'"
              @click:append="showPassword = !showPassword"
              :rules="confirmPasswordRules"
            ></v-text-field>
          </v-card-text>

          <v-divider class="mt-4"></v-divider>
          <v-card-actions>
            <v-btn  color="primary" flat @click="switchForms">{{(loginState)?$t('acc_sign_up'):$t('acc_log_in')}}</v-btn>
            <v-spacer></v-spacer>
            <v-btn 
              type="submit" 
              color="primary" 
              :loading="loading" 
              :disabled="disabled" 
              flat
            >
              {{(loginState)?$t('acc_log_in'):$t('next_btn')}}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-flex>

    <v-snackbar v-model="showCoreMessage" :right="true" :timeout="5000" :top="true" color="secondary">
      {{ coreMessage }}
      <v-btn flat @click="showCoreMessage = false">Close</v-btn>
    </v-snackbar>
  </v-layout>
  
</template>

<style>
</style>

<script>
  import { EventBus } from '@/event-bus.js'
  import coreStringsGetter from '@utils/coreStringsGetter'

  //TODO: rules
  // https://github.com/vuetifyjs/vuetifyjs.com/blob/master/src/examples/text-fields/password.vue
  // https://github.com/L-K-Mist/feathers-chat-vuetify-pwa/blob/master/src/components/authentication/LogIn.vue
    
  export default {
    name: 'login',
    data () {
      return {
        showPassword: false,
        username: '',
        password: '',
        confirmPassword: '',
        loginState: true,
        valid: false,
        usernameRules: [
          v => !!v || this.$t('acc_username_empty'),
          v => /^\w{3,11}$/.test(v) || this.$t('acc_username_alphanumeric')
        ],
        passwordRules: [
          v => !!v || this.$t('acc_passwords_empty'),
          v => /^(?=.{6,25})(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).*$/.test(v) || this.$t('reg_hint_password')
        ],
        confirmPasswordRules: [
          v => v == this.password || this.$t('acc_passwords_not_equal')
        ],
        showCoreMessage: false,
        coreMessage: "coreMessage",
        loader: null,
        loading: false,
      }
    },
    computed: {
      disabled() {
        return this.loading || !this.valid
      }
    },
    methods: {
      switchForms() {
        this.loginState=!this.loginState 
        this.$refs.form.reset()
      },
      login() {
        this.loader = 'loading'
        this.$refs.form.validate()

        if(!this.valid) {
          this.resetLoader()
          return
        }

        const { username, password } = this
        if (this.loginState) {
          EventBus.sendLogin(username, password, () => {
            this.$router.push({name:'Main'})
          })
        } else {
          EventBus.createAccount(username, password, () => {
            this.$router.push({name:'Main'})
          })
        }
      },
      showMessage(args) {
        console.log("showMessage")
        const message = coreStringsGetter.getStringById(args.id)
        this.coreMessage = args.arg ? this.$t(message, [args.arg]) : this.$t(message)
        this.showCoreMessage = true
        this.resetLoader()
      },
      resetLoader() {
        this.loading = false
        const l = this.loader
        this[l] = false
        this.loader = null
      },
    },
    mounted() {
      EventBus.$on('show-message', this.showMessage)
    },
    beforeDestroy() {
      EventBus.$off('show-message')
    },
    watch: {
      loader () {
        const l = this.loader
        this[l] = !this[l]
        setTimeout(() => (this[l] = false), 3000)
        this.loader = null
      }
    }
  }
  
</script>